import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import ReportsAPI from '../../../../Reports/api/reports_api';

const generateDocDefTemplate2 = async (obj) => {
    console.log("DATAINVOICEPDF", obj);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const city = sessionStorage.getItem('id_ciudad');
    const dept =parseInt(sessionStorage.getItem('id_dpto'));
    const getCity = await ReportsAPI.loadCity(city);
    const getDepts = await ReportsAPI.loadDepartment();
    const deptoProfile= getDepts.find((depto)=>depto.id === dept)
    console.log(deptoProfile)

    let cityReport= getCity.length > 0 ? getCity[0].ciunom : ' ';
    let deptoReport = deptoProfile !== null ? deptoProfile.depnom : '';

    let cantItems = 0;
    for (var i = 0; i < obj.items.length; i++) {
        cantItems = cantItems + 1;
    }
    let acc_valor_iva = obj.items.reduce((prev, current) => {
        let acc = prev + current.valor_iva;
        //console.log("PREV", prev, "CURRENT", current)
        return acc;
    }, 0);

    let emision = new Date(obj.fecha_emision);
    //let expirationDate = obj.recibosCaja[0].diasvencimiento != null && obj.recibosCaja[0].diasvencimiento != undefined ? parseInt(obj.recibosCaja[0].diasvencimiento) : 30;
    //let expirationDateinvoice = new Date();
    //let expirationDateinvoice = moment(emision).add(expirationDate, 'days').format("YYYY-MM-DD")
    const formatNumber = (num) => {
        num = num + ''; // Número a cadena
        var str = ""; // Acumulación de cadenas
        for (var i = num.length - 1, j = 1; i >= 0; i--, j++) {
            if (j % 3 == 0 && i != 0) {// Se agrega una coma cada tres dígitos para filtrar el caso donde es exactamente el primer dígito
                str += num[i] + ","; // Agrega una coma de miles
                continue;
            }
            str += num[i]; // Para acumular números al revés
        }
        return str.split('').reverse().join(""); // String => Array => Reverse => String
    };

    //Tabla de Informacion Juridica
    let tipDoc = obj.esFactura == true ? "Factura Electrónica de Venta" : "Cuenta de Cobro";
    let itemBodyInformation = [];

    let tipo_contribuyente = obj.profile.tipo_contribuyente !== null && obj.profile.tipo_contribuyente !== undefined ? obj.profile.tipo_contribuyente : 0;
    let name_contribuyente;
    switch (parseInt(tipo_contribuyente)) {
        case 1:
            name_contribuyente = 'PERSONA NATURAL'
            break;
        case 2:
            name_contribuyente = 'PERSONA JURIDICA'
            break;
        default:
            name_contribuyente = '';
            break;
    }

    let casilla1 =
        "Cliente: " + obj.nombre_facturado + "\n" +
        "NIT: " + obj.num_documento + "\n" +
        "Direccion: " + obj.direccion + "\n" +
        "Telefono: " + obj.telefono + "\n" +
        "Email: " + obj.correo + "\n\n" /*+
        "Tipo de Negociación: " + obj.recibosCaja[0].tipo_pago + "\n" +
        "Medio de Pago: " + obj.recibosCaja[0].forma_pago + "\n" +*/
        /*"Fecha de Vencimiento: " + expirationDateinvoice*/;
    let casilla2 =
        tipDoc + "\n" +
        "Moneda: COP Colombia,pesos \n" +
        "No: " + obj.num_fac_ter + "\n" +
        "Fecha Emision: " + obj.fecha_emision + "\n\n" +
        "Total de lineas o items: " + cantItems + "\n";

     itemBodyInformation.push([
         { text: casilla1, alignment: "left" },
         { text: casilla2, alignment: "left" },
     ]);

     const header = {
        margin: [0, 0, -10, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', 'auto', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                    fit: [180, 90],
                    alignment: 'center'
                },
                {
                    layout: 'noBorders',
                    table: {
                        body: [
                            [{ text: obj.profile.nombre, style: 'head', alignment: 'center' }],
                            [{ text: 'NIT: : ' + obj.profile.nit, style: 'texthead', alignment: 'center' }],
                            [{ text: name_contribuyente, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.direccion.direccion, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.telefono1, style: 'texthead', alignment: 'center' }],
                            [{ text: obj.profile.email, style: 'texthead', alignment: 'center' }],
                            [{ text: cityReport + ', ' + deptoReport, style: 'texthead', alignment: 'center' }],
                        ],
                        alignment: 'center',
                    },
                },
                {
                    width: "*",
                    columns: [
                        await propsQRCode(obj.urlDian)
                    ],
                    alignment: 'center'
                },],
            ],
        },
    };

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "#",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Descripcion",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Cantidad",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Precio U",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "IVA",
                style: "tableHeader",
                alignment: "center",
            },
            {
                text: "Total",
                style: "tableHeader",
                alignment: "center",
            },
        ],
    ];
    let itemArr = ["", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        itemBody.push([
            { text: index + 1, alignment: "center" },
            { text: element.item_nombre.toUpperCase(), alignment: "center" },
            { text: element.cantidad, alignment: "center" },
            { text: '$' + formatNumber(element.costo), alignment: "center" },
            { text: isNaN(element.valor_iva) ? '$' + 0 : '$' + formatNumber(element.valor_iva), alignment: "center" },
            { text: '$' + formatNumber(element.valor_total.toFixed()), alignment: "center" },
        ]);
    }

    //Tabla de Informacion Juridica
    let itemBodyObservation = [];
    let casilla1tot = "Observaciones:";
    itemBodyObservation.push([
        { text: casilla1tot, alignment: "left" }
    ]);

    //Tabla de Informacion Juridica
    let itemBodyTotals = [];
    itemBodyTotals.push(
        [
            { text: 'Subtotal', alignment: "left", bold: true },
            { text: '$' + formatNumber(obj.total.toString()), alignment: "left" }
        ],
        [
            { text: 'Cargos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Descuentos', alignment: "left", bold: true },
            { text: '$0.0', alignment: "left" }
        ],
        [
            { text: 'Abonos', alignment: "left", bold: true },
            { text: '$' + formatNumber(obj.copago.toString()), alignment: "left" }
        ],
        [
            { text: 'Iva', alignment: "left", bold: true },
            { text:  isNaN(acc_valor_iva) ? '$' +  0 : '$' + formatNumber(acc_valor_iva), alignment: "left" }
        ],
        [
            { text: 'Total de la Operacion', alignment: "left", bold: true },
            { text: '$' + formatNumber(obj.neto.toString()), alignment: "left" }
        ]
    );


    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    const validateFooterAutorization = (obj) => {
        if (obj.esFactura == true) {
            let foot = {
                text: obj.autorizacion_text,
                fontSize: 9,
                alignment: "center"
            }
            return foot;
        }
        else {
            return null;
        }
    }

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        info: {
            title: "Factura No#" + obj.num_fac_ter,
            author: "",
        },
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/
        /*
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                        },
                    ],
                },
            ];
        },
        */
        content: [
            header,
            {
                text: obj.cufe != null ? "\n\n\n CUFE/CUDE:" + obj.cufe : "\n\n\n",
                fontSize: 9,
            },
            {
                style: "tableTop",
                table: {
                    headerRows: 1,
                    widths: [270, 270],
                    body: itemBodyInformation,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                },
                dontBreakRows: true,
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: [30,140,75,80,80,80],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
            {
                columns: [
                    {
                        style: "tableExample2",
                        table: {
                            headerRows: 1,
                            widths: [275],
                            heights: [100],
                            //keepWithHeaderRows: 1,
                            body: itemBodyObservation,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                    },
                    {
                        style: "tableExample3",
                        table: {
                            headerRows: 1,
                            widths: [120, 120],
                            //keepWithHeaderRows: 1,
                            body: itemBodyTotals,
                        },
                        layout: "exampleLayout",
                        dontBreakRows: true,
                        relativePosition: { x: -10 }
                    }
                ]
            },
            validateFooterAutorization(obj),
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: 9
            },
            tableExample2: {
                margin: [0, 5, 0, 0],
                fontSize: 9
            },
            tableExample3: {
                margin: [0, 5, 0, 0],
                fontSize: 9,
            },
            tableTop: {
                margin: [0, 0, 0, 0],
                fontSize: 8,
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
            textStyle: {
                fontSize: 9,
                alignment: "left"
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

const propsQRCode = async (urlDian) => {
    if (urlDian != null) {
        return {
            image: await getBase64ImageFromURL("https://api.qrserver.com/v1/create-qr-code/?data=" + urlDian),
            width: 100,
            height: 100,
        }
    }
    else {
        return {}
    }
}
export default generateDocDefTemplate2;